module.exports = __webpack_public_path__ + "static/media/furnishing-photo-product.8a19bb7c.jpg";